module.exports = __webpack_public_path__ + "static/media/view investigation exclusion.4eead57b.svg";